import { PropsWithChildren, useCallback, useEffect, useRef, useState } from 'react'
import { runOnClient } from '@shared/pipes/client'
import { scrollIntoViewByParent } from '@shared/pipes/scroll'

import { ITabsViewProps } from './model'
import { View } from './view'

export const Tabs = (props: PropsWithChildren<ITabsViewProps>) => {
	const tabsRef = useRef<HTMLElement>(null)
	const [selectedIndex, setSelectedTabIndex] = useState(props.selectedIndex ?? 0)

	useEffect(() => {
		runOnClient(() => {
			if (tabsRef.current) {
				const tabList = tabsRef.current.querySelector('[role="tablist"]')
				if (tabList) {
					const tabs = tabList.querySelectorAll('[role="tab"]')
					if (tabs[selectedIndex]) {
						scrollIntoViewByParent(tabs[selectedIndex])
					}
				}
			}
		})
	}, [selectedIndex])

	useEffect(() => {
		if (typeof props.selectedIndex !== 'undefined' && props.selectedIndex !== selectedIndex) {
			setSelectedTabIndex(props.selectedIndex)
		}
	}, [props.selectedIndex, selectedIndex])

	const handleSelectTab = useCallback(
		(index: number) => {
			if (typeof props.selectedIndex === 'undefined') {
				setSelectedTabIndex(index)
			}

			if (props.onSelectIndex) {
				props.onSelectIndex(index)
			}
		},
		[setSelectedTabIndex]
	)

	return View({
		getDomNode: (node) => ((tabsRef.current as any) = node),
		selectedIndex,
		data: props.data,
		onSelectIndex: handleSelectTab,
	})
}
